import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Table } from "primeng/table";
import { TableModule } from "primeng/table";
import { UserWalletService } from "src/app/services/userWallet.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { ConfirmationService, MessageService } from "primeng/api";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { CustomValidators } from "ng2-validation";
import { WindowRefService } from "src/app/services/window-ref.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";
@Component({
  selector: 'app-academy-wallet',
  templateUrl: './academy-wallet.component.html',
  styleUrls: ['./academy-wallet.component.scss'],
  providers: [ConfirmationService, MessageService, WindowRefService],
})
export class AcademyWalletComponent implements OnInit {
 availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  bodyClass: string;
  public walletlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  downloadFlg: boolean;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  totalCash;
  totalDeductedCash;
  addCashmodal: boolean = false;
  showThankyouModal: boolean = false;
  addCoinmodal: boolean = false;
  totalAvailableCash;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public userId;
  addCashForm: FormGroup;
  addCoinForm: FormGroup;
  submitted = false;
  coinsubmitted = false;
  @ViewChild("dt", { static: false }) public dt: Table;
  constructor(
    private tokenStorage: TokenStorageService,
    private route: ActivatedRoute,
    private userWalletService: UserWalletService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private winRef: WindowRefService,
    private router: Router,
    private formBuilder: FormBuilder,
    private walletpaymentService: WalletpaymentService
  ) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
    }
    this.addCashForm = this.formBuilder.group({
      amount: ["", [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
    });
    this.addCoinForm = this.formBuilder.group({
      amount: ["", [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
    });
  }
   // convenience getter for easy access to form fields
   get f() {
    return this.addCashForm.controls;
  }
  get f1() {
    return this.addCoinForm.controls;
  }
  loadWalletHistory(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query =
      "?filterByDisable=false&filterByUserid=" +
      this.userId +
      "&sortBy=created_at&orderBy=DESC";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    // at the time of download hide pagination option
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }

    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    this.userWalletService.getUserWalletList(query).subscribe(
      (data) => {
        this.loading = false;
        this.walletlist = data.data.items;
        this.totalCash = data.data.totalCash;
        this.totalDeductedCash = data.data.totalDeductedCash;
        this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
        this.totalCoins = data.data.totalCoins;
        this.totalDeductedCoin = data.data.totalDeductedCoin;
        this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        this.totalRecords = data.data.totalCount;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  addCash() {
    this.addCoinmodal = false;
    this.addCashmodal = true;
  }

  onCashSubmit() {
    this.submitted = true;
    if (this.addCashForm.invalid) {
      return;
    }
    var addCashData = this.addCashForm.value;
    addCashData["userId"] = this.userId;    
    if (addCashData['amount'] > 0) {
      this.addCashmodal = false;
      addCashData = JSON.stringify(addCashData, null, 4);
      const amt = addCashData["amount"];
      console.log(amt);
      this.walletpaymentService
        .addWalletPayment(addCashData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCashForm.value.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Cash to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.userId,
              walletType: "CASH",
              amount: this.addCashForm.value.amount,
            };
            // call your backend api to verify payment signature & capture transaction
            this.walletpaymentService
              .verifyWalletpayment(verifyPaymentData)
              .subscribe((paymentdata) => {
                window.scroll(0, 0);
                this.showThankyouModal = true;
                this.addCashForm.reset();
                this.addCoinForm.reset();
                let currentUrl = this.router.url;
                this.router
                  .navigateByUrl("/", { skipLocationChange: true })
                  .then(() => {
                    this.router.navigate([currentUrl]);
                  });
                window.location.reload();
              });
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
            console.log("Transaction cancelled.");
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        });
    }
  }
  cashclose() {
    this.submitted = false;
    //this.addCashForm.get('amount').reset();
    //this.addCashForm.reset();
  }

  closeThankyou() {
    this.showThankyouModal = false;
    let currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  addCoin() {
    this.addCashmodal = false;
    this.addCoinmodal = true;
  }

  onCoinSubmit() {
    this.coinsubmitted = true;
    if (this.addCoinForm.invalid) {
      return;
    }
    var addCoinData = this.addCoinForm.value;
    addCoinData["userId"] = this.userId;
    if (addCoinData["amount"] > 0) {
      this.addCoinmodal = false;
      addCoinData = JSON.stringify(addCoinData, null, 4);
      this.walletpaymentService
        .addWalletPayment(addCoinData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCoinForm.value.amount * 10 * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Coins to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.userId,
              walletType: "COINS",
              amount: this.addCoinForm.value.amount,
            };
            // call your backend api to verify payment signature & capture transaction
            this.walletpaymentService
              .verifyWalletpayment(verifyPaymentData)
              .subscribe((paymentdata) => {
                window.scroll(0, 0);
                this.showThankyouModal = true;
                let currentUrl = this.router.url;
                this.addCashForm.reset();
                this.addCoinForm.reset();
                // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                //   this.router.navigate([currentUrl]);
                // });
                window.location.reload();
              });
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
            console.log("Transaction cancelled.");
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        });
    }
  }

  transferAmountToBank(id) {
    this.router.navigate(['my-wallet/wallet-redemption/'+id]);
}
kyclink(id) {
    this.router.navigate(['kyc-update']);
}

  coinclose() {
    this.coinsubmitted = false;
    //this.addCoinForm.reset();
  }
}
